import { DatePipe } from "@angular/common";
import { Component, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RoutesRecognized,
} from "@angular/router";
import { OwlOptions } from "ngx-owl-carousel-o";
import { ToastrService } from "ngx-toastr";
import { API_ROUTES } from "src/app/core/_constants/api-route.constant";
import { ApiServicesService } from "src/app/services/apiServices/api-services.service";
// import { SubjectserviceService } from 'src/app/services/subjectService/subjectservice.service';
import { InterestedComponent } from "src/app/shared/dialogs/interested/interested.component";
import { PostPublishComponent } from "src/app/shared/dialogs/post-publish/post-publish.component";
import { Location } from "@angular/common";
import { CommonService } from "src/app/services/common.service";
import { ShareComponent } from "src/app/modules/pages/home/share/share.component";
import { RouteConstant } from "src/app/core/_constants/route.constant";
import { LocalStorageProvider } from "src/app/services/storage/storage.service";
import { filter, fromEvent, pairwise } from "rxjs";
import { SearchService } from "src/app/services/search.service";
import { DataService } from "src/app/services/data.service";
import { WhatsappServiceService } from "src/app/services/chatService/whatsapp-service.service";
import { environment } from "src/environments/environment";
import { LogoutComponent } from "src/app/shared/dialogs/logout/logout.component";
@Component({
  selector: 'app-tools',
  templateUrl: './tools.component.html',
  styleUrls: ['./tools.component.scss']
})
export class ToolsComponent {
  productData: any;
  images: any = [];
  videos: any = [];
  businessActivity: any = [];
  industry: any = [];
  pdf: any = [];
  productId: any;
  type: any;
  Media: any = [];
  imageObject: any = [];
  customOptions: OwlOptions = {
    loop: false,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: true,
    margin: 10,
    navSpeed: 700,
    navText: [
      '<img src="assets/images/home-1.svg" class="nav-icon">',
      '<img src="assets/images/home.svg" class="nav-icon">',
    ],
    autoplay: false,
    autoplayTimeout: 2000,
    items: 1,
    nav: true,
  };
  profileDetails: any;
  owner: boolean = false;
  status: any;
  guestUser: string | null;
  filter: any;
  category: any;
  hiddenInterestBtn: boolean = true;
  previousUrl: any;
  newArrivalsList: any;
  popularList: any;
  bestSellerList: any;
  otherProducts: any;
  productDetailScreen: any = "/" + RouteConstant.main + "/" + RouteConstant.marketPlaceList + "/" + RouteConstant.marketplaceProductDetail;
  filterAPIData: any;
  from: any;
  stoken: any;
  selectedImage: { url: string } | undefined;

  constructor(
    public datepipe: DatePipe,
    private dialog: MatDialog,
    private storageService: LocalStorageProvider,
    private service: ApiServicesService,
    private commonService: CommonService,
    private activeRoute: ActivatedRoute,
    private searchService: SearchService,
    private router: Router,
    private toastr: ToastrService,
    private dataService: DataService,
    private location: Location, public dialogRef: MatDialog,
    private whatsAppService: WhatsappServiceService, private route: ActivatedRoute
  ) {
    if (this.productId) {
      this.productId = null;
      this.productData = null;
      this.profileDetails = null;
    }
    this.stoken = localStorage.getItem("stoken");
    if (this.stoken) {
      this.activeRoute.queryParams.subscribe((params) => {
        this.productId = params?.["productId"];
        this.type = params?.["type"];
        this.status = params?.["status"];
        this.filter = params?.["filter"];
        this.category = params?.["category"];
        this.from = params?.["from"]
      });
    }
    else {
      this.service.Login();
    }
  }
  ngOnInit(): void {
    this.guestUser = localStorage.getItem("guestUser");
    this.stoken = localStorage.getItem("stoken");
    if (this.stoken) {
      this.getProductDetails();
      this.openProduct();
      this.route.queryParams.subscribe(params => {
        this.productId = params['productId'];
        if (this.productId) {
          this.getProductDetails();
        }
      });
    } else {
      this.service.Login();
    }
  }
  onImageClick(img: { url: string }) {
    this.selectedImage = img;  // Update the main image to the clicked small image
  }
  viweallrel: boolean = false;
  viweall: boolean = false;
  viwelessrel: boolean = false;
  viweless: boolean = false;
  moreFromSeller: any;
  relatedProducts: any;
  cityDetails: any;
  stateDetails: any;
  getProductDetails() {
    console.log("getProductDetails");
    let url = this.guestUser
      ? API_ROUTES.Marketplace.productDetailsGuest
      : API_ROUTES.Marketplace.productDetails;

    this.service
      .get({ productId: this.productId }, url)
      .pipe()
      .subscribe({
        next: (res) => {
          if (res.success) {
            console.log(res.result, 'service data');
            this.productData = res.result.productDetails;
            this.stateDetails = this.productData.stateDetails;
            this.cityDetails = this.productData.cityDetails;
            this.isInWishlist = this.productData?.interestShown === true;
            this.Media = this.productData.Media;
            this.images = this.productData.Media;
            if (this.images && this.images.length > 0) {
              this.selectedImage = this.images[0];
            }
            this.moreFromSeller = res.result.moreFromSeller.slice(0, 4);
            this.relatedProducts = res.result.relatedProducts.slice(0, 4);
            this.hiddenInterestBtn = this.productData?.interestShown || false;
            if (res.result.moreFromSeller?.length > 4) {
              this.viweall = true;
            }
            if (res.result.relatedProducts?.length > 4) {
              this.viweallrel = true;
            }
            if (
              !this.guestUser &&
              this.productData.Auth?.CompanyInfo?.company_name?.toLowerCase() ===
              this.profileDetails?.company_name?.toLowerCase()
            ) {
              this.owner = true;
            }

            if (this.productData.Media && this.productData.Media.length > 0) {
              this.imageObject = this.commonService.slidesArranging(
                this.productData,
                this.productData.id
              );
            }

            this.getPopularProducts();
            this.getOtherproductsFromPopSeller();
          }
        },
        error: (error) => {
          if (error.error_code === 404) {
            this.toastr.error("Respective Product has been removed");
            this.router.navigate([
              "/" + RouteConstant.main + "/" + RouteConstant.home,
            ]);
          } else {
            this.toastr.error(this.commonService.returnErrorMessage(error));
          }
        },
        complete: () => {
          // Optionally handle completion here
        }
      });
  }
  isInWishlist: boolean;
  toggleWishlist() {
    console.log(this.isInWishlist, 'isInWishlist');

    // Ensure productId is defined before proceeding
    if (!this.productId) {
      console.error("productId is undefined");
      this.toastr.error("Product ID is missing.");
      return;  // Exit the function if productId is not defined
    }

    // Toggle the wishlist state first
    this.isInWishlist = !this.isInWishlist;

    const url = this.isInWishlist
      ? API_ROUTES.Account.addToWishlist
      : API_ROUTES.Account.removewishlist;

    const httpMethod = this.isInWishlist ? 'post' : 'delete';

    // Log URL and method to verify
    console.log('Calling API with URL:', url);

    // For POST, we send the productId in the request body, for DELETE, it's a URL parameter
    if (httpMethod === 'post') {
      // For POST (Add to Wishlist), send the productId in the request body
      this.service[httpMethod]({ productId: this.productId }, url, {})
        .pipe()
        .subscribe({
          next: (res) => {
            if (res.success) {
              this.toastr.success(res.message);
              console.log(res, 'added to wishlist');
            }
          },
          error: (error) => {
            this.toastr.error(this.commonService.returnErrorMessage(error));
          }
        });
    } else {
      // For DELETE (Remove from Wishlist), send the productId in the URL parameters
      const payload = { product_id: this.productId };  // Ensure productId is passed
      this.service[httpMethod](payload, url)
        .pipe()
        .subscribe({
          next: (res) => {
            if (res.success) {
              this.toastr.success(res.message);
              console.log(res, 'removed from wishlist');
            }
          },
          error: (error) => {
            this.toastr.error(this.commonService.returnErrorMessage(error));
          }
        });
    }
  }

  viewSingleProduct(productId: string, category: string) {
    console.log(category, "category");
    if (category == 'Machine') {
      this.router.navigate([RouteConstant.machine], { queryParams: { productId: productId } }).then(() => {
        window.scrollTo(0, 0);
      });
    } else if (category == 'Services') {
      this.router.navigate([RouteConstant.service], { queryParams: { productId: productId } }).then(() => {
        window.scrollTo(0, 0);
      });
    } else if (category == 'Tools') {
      this.router.navigate([RouteConstant.tools], { queryParams: { productId: productId } }).then(() => {
        window.scrollTo(0, 0);
      });
    } else if (category == 'Raw Material') {
      this.router.navigate([RouteConstant.rawmaterials], { queryParams: { productId: productId } }).then(() => {
        window.scrollTo(0, 0);
      });
    }
  }
  userProfile: any;
  getProfile() {
    console.log("getProfile")
    this.service
      .get({}, `${API_ROUTES.More.moreDetails}`)
      .pipe()
      .subscribe(
        (res) => {
          if (res) {
            this.profileDetails = res.result[0];
            this.userProfile = res.result[res?.result?.length - 1];
            this.getProductDetails();
          }
        },
        (error) => {
          this.toastr.error(error.message);
        }
      );
  }
  openProduct() {
    this.dataService.product$.subscribe(res => {
      if (res?.productId) {
        this.productId = null;
        this.productId = res?.productId;
        this.type = res?.type;
        this.getProductDetails();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    })
  }

  getPopularProducts() {
    const params = {
      auth_id: this.productData?.auth_id,
      product_id: this.productData?.id,
      category: this.productData?.category3_id,
      page: 1,
      size: 20
    }
    // this.service.get(params, API_ROUTES.Marketplace.popularProducts).subscribe(res => {
    //   this.popularList = res.result;
    //   if (this.popularList) {
    //     for (let i = 0; i < this.popularList?.length; i++) {
    //       let image = this.popularList[i].Media.find((element: any) =>
    //         element.media_type.toLowerCase().includes("image")
    //       );
    //       if (image) {
    //         this.popularList[i].shapeImageUrl = image.url;
    //       }
    //       else if (
    //         this.popularList[i].Media.find((element: any) =>
    //           element.media_type.toLowerCase().includes("video")
    //         )
    //       ) {
    //         let video = this.popularList[i].Media.find((element: any) =>
    //           element.media_type.toLowerCase().includes("video")
    //         );

    //         this.popularList[i].shapeImageUrl = video.thumbnail_url
    //           ? video.thumbnail_url
    //           : "assets/images/placeholder-img.svg";
    //       } else {
    //         this.popularList[i].shapeImageUrl =
    //           "assets/images/placeholder-img.svg";
    //       }
    //     }
    //   }
    // })
  }

  getOtherproductsFromPopSeller() {
    const params = {
      auth_id: this.productData?.auth_id,
      product_id: this.productData?.id,
      page: 1,
      size: 20
    }
    // this.service.get(params, API_ROUTES.Marketplace.popularProducts).subscribe(res => {
    //   this.otherProducts = res.result;
    //   if (this.otherProducts) {
    //     for (let i = 0; i < this.otherProducts?.length; i++) {
    //       let image = this.otherProducts[i].Media.find((element: any) =>
    //         element.media_type.toLowerCase().includes("image")
    //       );
    //       if (image) {
    //         this.otherProducts[i].shapeImageUrl = image.url;
    //       }
    //       else if (
    //         this.otherProducts[i].Media.find((element: any) =>
    //           element.media_type.toLowerCase().includes("video")
    //         )
    //       ) {
    //         let video = this.otherProducts[i].Media.find((element: any) =>
    //           element.media_type.toLowerCase().includes("video")
    //         );

    //         this.otherProducts[i].shapeImageUrl = video.thumbnail_url
    //           ? video.thumbnail_url
    //           : "assets/images/placeholder-img.svg";
    //       } else {
    //         this.otherProducts[i].shapeImageUrl =
    //           "assets/images/placeholder-img.svg";
    //       }
    //     }
    //   }
    // })
  }














  isGetQuote: boolean;
  toggleGetQuote() {
    // Ensure productId is defined before proceeding
    if (!this.productId) {
      console.error("productId is undefined");
      this.toastr.error("Product ID is missing.");
      return;  // Exit the function if productId is not defined
    }
    const url = API_ROUTES.MyRequirements.addToGetQuote;
    // For POST (Add to Wishlist), send the productId in the request body
    this.service.post({ productId: this.productId }, url, {})
      .pipe()
      .subscribe({
        next: (res) => {
          if (res.success) {
            this.dialogRef.open(LogoutComponent, {
              maxHeight: '100vh',
              width: '50%',
              data: {
                img: '../assets/images/new_img/Group.svg',
                heading: 'Your Requirement has been shared with the seller',
                para: "Thank you for showing interest." +
                  "We will get back to you as soon as possible."
              }
            })
            this.toastr.success(res.message);
            console.log(res, 'added to quote');
          }
        },
        error: (error) => {
          this.toastr.error(this.commonService.returnErrorMessage(error));
        }
      });
    // else {
    //   // For DELETE (Remove from Wishlist), send the productId in the URL parameters
    //   const payload = { quoteId: this.productId };  // Ensure productId is passed
    //   this.service[httpMethod](payload, url)
    //     .pipe()
    //     .subscribe({
    //       next: (res) => {
    //         if (res.success) {
    //           console.log(res, 'removed from wishlist');
    //         }
    //       },
    //       error: (error) => {
    //         this.toastr.error(this.commonService.returnErrorMessage(error));
    //       }
    //     });
    // }
  }

  viewAllProductsFromSeller(name: any) {
    this?.getAllProductsFromSeller(name);

  }
  viewLessProductsFromSeller(viewLessProducts: any) {
    this?.getAllProductsFromSeller(viewLessProducts);
  }
  viewAllProductsFromRelated(name: any) {
    this?.getAllProductsFromRelated(name)

  }
  viewLessProductsFromRelated(viewLessProduct: any) {
    this?.getAllProductsFromRelated(viewLessProduct)
  }

  getAllProductsFromSeller(productType: string) {
    let url = this.guestUser
      ? API_ROUTES.Marketplace.productDetailsGuest
      : API_ROUTES.Marketplace.productDetails;

    this.service
      .get({ productId: this.productId }, url)
      .pipe()
      .subscribe({
        next: (res) => {
          if (res.success) {
            this.moreFromSeller = productType === 'lessFromSeller' ? res.result.moreFromSeller.slice(0, 4) : res.result.moreFromSeller;
            this.viweall = productType === 'lessFromSeller' ? true : false;
            this.viweless = productType === 'lessFromSeller' ? false : true
            console.log("Full list from the seller", this.moreFromSeller);
          }
        },
        error: (error) => {
          this.toastr.error(this.commonService.returnErrorMessage(error));
        }
      });
  }
  navigatOnProfile() {
    // this.authIdService.setAuthId(this.productData?.auth_id);
    // this.router.navigate(['/main/company-profile']);
    this.router.navigate(['/main/company-profile'], {
      queryParams: { status: this.productData?.auth_id }
    });
  }
  getAllProductsFromRelated(productType: string) {
    let url = this.guestUser
      ? API_ROUTES.Marketplace.productDetailsGuest
      : API_ROUTES.Marketplace.productDetails;

    this.service
      .get({ productId: this.productId }, url)
      .pipe()
      .subscribe({
        next: (res) => {
          if (res.success) {
            this.relatedProducts = productType === 'lessrelatedProducts' ? res.result.relatedProducts.slice(0, 4) : res.result.relatedProducts;
            this.viweallrel = productType === 'lessrelatedProducts' ? true : false;
            this.viwelessrel = productType === 'lessrelatedProducts' ? false : true;
            console.log("Full list of related products", this.relatedProducts);
          }
        },
        error: (error) => {
          this.toastr.error(this.commonService.returnErrorMessage(error));
        }
      });
  }

}
